import en from './en.json';
import ja from './ja.json';
import zh from './zh.json';
import zt from './zt.json';
import es from './es.json';
import fr from './fr.json';
import ru from './ru.json';

export default {
  en,
  ja,
  zh,
  zt,
  fr,
  es,
  ru
};
